import { ApiError } from '@anm/api';
import { JobIdFromSourceParams, JobIdFromTextParams, JobIdResponse } from '@anm/api/modules/storyboard';
import { createAction, createAsyncAction } from '@anm/helpers/saga/typesafe-actions';

export const fetchUrlJobId = createAction('wave.video/storyboard/FETCH_URL_JOB_ID')<JobIdFromSourceParams>();

export const fetchUrlJobIdAsync = createAsyncAction(
  'wave.video/storyboard/FETCH_URL_JOB_ID_REQUEST',
  'wave.video/storyboard/FETCH_URL_JOB_ID_SUCCESS',
  'wave.video/storyboard/FETCH_URL_JOB_ID_FAILURE'
)<JobIdFromSourceParams, JobIdResponse, ApiError>();

export const fetchTextJobId = createAction('wave.video/storyboard/FETCH_TEXT_JOB_ID')<JobIdFromTextParams>();

export const fetchTextJobIdAsync = createAsyncAction(
  'wave.video/storyboard/FETCH_TEXT_JOB_ID_REQUEST',
  'wave.video/storyboard/FETCH_TEXT_JOB_ID_SUCCESS',
  'wave.video/storyboard/FETCH_TEXT_JOB_ID_FAILURE'
)<JobIdFromSourceParams, JobIdResponse, ApiError>();

export const clearJobId = createAction('wave.video/storyboard/CLEAR_JOB_ID')();
